<!-- 由 suu 创建于 2021-08-25 星期三 -->
<template>
  <div class="course-info">
    <!-- 头部背景 -->
    <div class="dt-top"></div>
    <!-- 上方扫码信息 -->
    <InfoScanCode :info="info" @getPid="getPlan"></InfoScanCode>
    <!-- 课程训练计划 -->
    <InfoPlan :info="info" v-if="info.target"></InfoPlan>
  </div>
</template>

<script>
import InfoScanCode from './ponents/InfoScanCode.vue'
import InfoPlan from './ponents/InfoPlan.vue'
export default {
  name: 'course-info',

  components: { InfoScanCode, InfoPlan },

  props: {},

  data() {
    return {
      info: {}
    }
  },

  computed: {},

  watch: {},

  created() {
    if (this.$route.query.info) {
      this.info = JSON.parse(this.$route.query.info)
    }
  },

  mounted() {},

  destroyed() {},

  methods: {
    /**
     * 通过Pid请求该节课训练计划
     */
    getPlan(pid) {
      // this.$toast.loading('获取训练计划中')
      this.$http
        .get('plan/OutlineUp?a=planDetail', {
          pid
        })
        .then((res) => {
          if (res.data.code === 200) {
            let plan = res.data.data || {}
            this.info = Object.assign({}, this.info, plan)
          } else {
            this.$dialog.alert({ message: res.data.msg })
          }
          this.$toast.clear()
        })
        .catch((err) => {
          this.$toast.clear()
        })
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.course-info {
  width: 100vw;
  min-height: 100vh;
  box-sizing: border-box;
  padding-bottom: 10vw;
  position: relative;
  background-color: #f9f9f9;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  .dt-top {
    width: 100%;
    height: 62vw;
    box-sizing: border-box;
    position: fixed;
    top: 0;
    left: 0;
    z-index: -1;
    background: url('https://cdnvue.gymcity.com.cn/uploads/yueke-unit-bg') 0 0 /
      100% auto repeat-y;
  }
}
</style>
